import HomePage from './pages/home';
import WithAuthenticator from './withAuthenticator';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import config from './amplifyconfiguration.json';
Amplify.configure(config);

const client = generateClient();

const App = () => {
  return (
    <div className="App">
        {/* <WithAuthenticator /> */}
        <HomePage />
    </div>
  );
};

export default App;
